// extracted by mini-css-extract-plugin
module.exports = {"chronometer":"Chronometer_chronometer__3M6TJ","chronometerText":"Chronometer_chronometerText__26F57"};